import { Button, FormControl, InputGroup } from "react-bootstrap";
import { TrashIcon, UserAddIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";
import { useCallback } from "react";

import { useCourseRegistration } from "../../services/CourseRegistrationProvider";

const AddGuestButton = ({
	courseId,
	guests
}) => {
	const {
		removeGuest,
		setCourseToAddGuest
	} = useCourseRegistration();

	const openGuestModal = useCallback(() => setCourseToAddGuest(courseId), [setCourseToAddGuest, courseId]);
	const handleRemoveGuest = useCallback(() => removeGuest(courseId), [removeGuest, courseId]);

	return guests
		? (
			<InputGroup className="w-auto event-guest">
				<InputGroup.Text>Guest:</InputGroup.Text>
				<FormControl defaultValue={`${guests.firstName} ${guests.lastName}`} readOnly />
				<Button onClick={handleRemoveGuest} size="sm" variant="danger">
					<TrashIcon className="i" />
				</Button>
			</InputGroup>
		) : <Button onClick={openGuestModal} size="sm"><UserAddIcon className="i" /> Add Family/Friend</Button>;
};

AddGuestButton.propTypes = {
	courseId: PropTypes.number.isRequired,
	guests: PropTypes.shape({
		firstName: PropTypes.string,
		lastName: PropTypes.string
	})
};

AddGuestButton.defaultProps = {
	guests: null
};

export default AddGuestButton;
